import React from "react";
import { ResourceDescriptor } from "./common";

const user_grant: ResourceDescriptor = {
    url: "user_grant",
    orders: {
        read: ["role", "user_contexts"],
    },
    crudActions: ["delete", "read"],
    renderers: {
        delete: {
            role: (val, data) => {
                return <div>{data.role.name}</div>;
            },
            user_contexts: (val, data) => {
                let contexts = [];
                console.log("data", data);
                for (let ctx of data["user_contexts"]) {
                    contexts.push(<div>{ctx.context_data?.name || ctx.context_data?.identifier}</div>);
                }
                return <div>{...contexts}</div>;
            },
        },
    },
    identifiers: ["role", "user_contexts"],
    expand: {
        read: ["user_grant.role.role_contexts", "user_grant.user_contexts.context", "user_grant.role.client"],
    },
};

export default user_grant;
